import i18n from 'i18next'
import classNames from 'classnames'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Select } from 'antd'
import PreloaderBlock from 'components/PreloaderBlock/PreloaderBlock'
import { parseThousandsGroups } from 'helpers/numbers'
import DashboardService from 'redux/middlewares/dashboard'
import { topsTypes, topsTypesLabels } from './constants/topsTypes'
import baseStyles from './styles/base.module.scss'
import selectStyles from './styles/headerSelect.module.scss'
import tableStyle from './styles/topTable.module.scss'

const TopPromotions = ({ globalStartDate, globalFinishDate }) => {
  const { t } = useTranslation()
  const [responseType, setResponseType] = useState(topsTypes.COUNT)

  // Load tops data
  const { data: topsPositions, isFetching: isTopsPositionsFetching } = useQuery(
    ['dashboard-tops-positions', globalStartDate, globalFinishDate, responseType],
    async () => {
      const response = await DashboardService.getOrdersTopPositionsStats({
        startDate: globalStartDate.toISOString(),
        finishDate: globalFinishDate.toISOString(),
        responseType,
      })

      return response.data.data
    },
    {
      staleTime: 1000 * 60 * 10, // 10 minute
      refetchOnMount: 'always',
    },
  )

  return (
    <div className={baseStyles.chart}>
      <div className={baseStyles.chart__header}>
        <div className={baseStyles.chart__headerTop}>
          <p className={baseStyles.chart__headerTitle}>{t('dashboard.top promotions')}</p>
          <div className={'field-wrapper'}>
            <Select
              className={selectStyles.headerSelect}
              options={[
                { value: topsTypes.COUNT, label: t(topsTypesLabels.COUNT) },
                { value: topsTypes.REVENUE, label: t(topsTypesLabels.REVENUE) },
              ]}
              value={responseType}
              onChange={(topsType) => setResponseType(topsType)}
            />
          </div>
        </div>
      </div>
      <div className={baseStyles.chart__body}>
        {!isTopsPositionsFetching && topsPositions?.areas ? (
          <div
            className={classNames([tableStyle.table, tableStyle.table_stickyHead])}
            style={{ maxHeight: 289 }}
          >
            <table>
              <thead>
                <tr>
                  <th className={tableStyle.rankColumn}>#</th>
                  <th className={tableStyle.promotionColumn}>{t('dashboard.promotion')}</th>
                  <th className={tableStyle.codeColumn}>{t('dashboard.promotion_code')}</th>
                  <th className={tableStyle.valueColumn}>{t(topsTypesLabels[responseType])}</th>
                </tr>
              </thead>
              <tbody>
                {topsPositions?.promotions.map((promotionStat, index) => {
                  return (
                    <tr key={promotionStat.promotion_id}>
                      <td className={tableStyle.rankCell}>{index + 1}</td>
                      <td className={tableStyle.promotionCell}>
                        {i18n.language === 'ar'
                          ? promotionStat.promotion_promotionArabicName
                          : promotionStat.promotion_promotionName}
                      </td>
                      <td className={tableStyle.codeCell}>
                        <span className={tableStyle.promotionCode}>
                          {promotionStat.promotion_sapId || 'N/A'}
                        </span>
                      </td>
                      {responseType === topsTypes.COUNT && (
                        <td className={tableStyle.valueCell}>{promotionStat.count}</td>
                      )}
                      {responseType === topsTypes.REVENUE && (
                        <td className={tableStyle.valueCell}>{parseThousandsGroups(promotionStat.revenue)}</td>
                      )}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <PreloaderBlock minHeight={248} />
        )}
      </div>
    </div>
  )
}

export default TopPromotions
